import { AppFeatures } from 'store/app/app.features'
import { setRedirect } from 'store/global/global.actions'

import * as callActions from '../../call/call.actions'

const setGeneralShortcuts = (store: any) => {
    document.addEventListener('keydown', (evt) => {
        const onInput: boolean | null | undefined =
            document.activeElement?.tagName === 'INPUT' ||
            document.activeElement?.tagName === 'TEXTAREA' ||
            document.activeElement?.hasAttribute('data-noshortcut')

        const hasFeature = (featureName: string) => {
            const agentFeatures = store.getState().auth?.features ?? []
            const appFeatures = store.getState().app.features ?? []
            return (
                appFeatures.some((f: any) => f.ID === featureName) &&
                agentFeatures.some((f: any) => f.ID === featureName || '*')
            )
        }

        function openNavElement(navElement: HTMLElement | null | undefined) {
            navElement?.querySelector('a')?.focus()
            navElement?.click()
        }

        if (!(evt.ctrlKey && evt.altKey)) return
        switch (
            evt.code //NAVIGATION SHORTCUTS - alt + shift + a single key
        ) {
            case 'KeyD': // Navigates to dialler page
                return onInput ? null : store.dispatch(setRedirect('/'))
            case 'KeyR': {
                // Navigates to real time metrics page
                if (hasFeature(AppFeatures.REALTIME_METRICS)) {
                    return onInput ? null : store.dispatch(setRedirect('/metrics/real-time'))
                }
                return
            }
            case 'KeyH': {
                // Navigates to historic metrics page
                if (hasFeature(AppFeatures.HISTORIC_METRICS)) {
                    return onInput ? null : store.dispatch(setRedirect('/metrics/historic'))
                }
                return
            }
            case 'KeyQ': {
                // Focus/Open QA submenu
                const navMenu: HTMLElement | null = document.querySelector('.menu')
                const QA: HTMLElement | null | undefined = navMenu?.querySelector(
                    '#sa--nav-element-quality-assurance',
                )
                return onInput ? null : openNavElement(QA)
            }
            case 'KeyS': {
                // Focus/Open Settings submenu
                const navMenu: HTMLElement | null = document.querySelector('.menu')
                const settingsMenuItem: HTMLElement | null | undefined = navMenu?.querySelector(
                    '#sa--nav-element-settings',
                )
                return onInput ? null : openNavElement(settingsMenuItem)
            }
            case 'Enter': {
                // Answers a call if the user is in dialler page and there is an incoming call
                const incomingCall = store.getState().call?.incoming
                const diallerPath = window.location.pathname === '/'
                return incomingCall && diallerPath ? store.dispatch(callActions.acceptCall()) : null
            }
        }
    })
}

export default setGeneralShortcuts
